/**
 * Shared upload limits + accept types for client-side dropzones.
 *
 * Server-side hard limit lives in app/api/upload/image/route.ts (10MB).
 * The pre-compression caps below are client-side only; oversize files
 * are rejected before they hit the network. Compression in
 * lib/image-compression.ts targets ~2MB output which sits comfortably
 * under the server cap.
 */

import type { Accept } from "react-dropzone"

export const UPLOAD_ACCEPT: Accept = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/heic": [".heic"],
  "image/heif": [".heif"],
}

/** Homepage absolute pre-compression cap. Mirrors the prior 25MB guard. */
export const UPLOAD_MAX_BYTES_HOMEPAGE = 25 * 1024 * 1024

/** Community-form pre-compression cap. */
export const UPLOAD_MAX_BYTES_COMMUNITY = 10 * 1024 * 1024
